import { CalendarCalendar, CalendarNewEvent, CalendarSidebar } from "features/calendar";
import { useCalendar } from "../lib/useCalendar"
import { useGlobalStore } from "entities/global";
import { useEffect } from "react";
import { usePageTitleStore } from "entities/pageTitle";
import { CalendarCalendarHead, CalendarWrapper, CaletdatFluidToTodayButton, DrawerDateWrapper, DrawerHivesWrapper } from "./styles";
import { useResize } from "app/lib/hooks/useResize";
import { Drawer } from 'shared/ui/drawer';
import PickerDate from '@atomaro/ui-kit/components/PickerDate/PickerDate';
import Button from '@atomaro/ui-kit/components/Button/Button/Button';
import { format, isToday } from "date-fns";
import { ru } from 'date-fns/locale';
import { COLORS } from "shared/consts";
import { SearchList } from "shared/ui/searchList";
import { useSearchParams } from "react-router-dom";

export const Calendar = () => {
  const { isScreenLg } = useResize();
  const [searchParams, setSearchParams] = useSearchParams();

  const setRouteTitle = usePageTitleStore(s => s.setRouteTitle)
  const resetDynamicTitle = usePageTitleStore(s => s.resetDynamicTitle)
  const setPlusButtonCallback = useGlobalStore(s => s.setPlusButtonCallback);

  const {
    events,
    isNewEventOpen,
    activeDate,
    isDateDrawerOpen,
    isHiveDrawerOpen,
    hiveListItems,
    setIsNewEventOpen,
    onChangeFilters,
    setIsDateDrawerOpen,
    setIsHiveDrawerOpen,
    onHiveListItemClick,
    onEventDrop,
    onEventResize,
  } = useCalendar();
  
  
  useEffect(() => {
    setRouteTitle('');
    resetDynamicTitle();
    setPlusButtonCallback(() => setIsNewEventOpen(true));

    document.title = 'Календарь'
    
    return () => {
      setPlusButtonCallback(null)
    }
  }, []);


  return (
    <CalendarWrapper $isMobile={!isScreenLg}>
      {isScreenLg ? 
        <CalendarSidebar 
          activeDate={activeDate}
          onPlusClick={() => setIsNewEventOpen(true)}
          onChangeFilters={onChangeFilters}
        /> : 
      <CalendarCalendarHead>
        <Button 
          label={format(activeDate, 'LLLL', {locale: ru})}
          variant='ghost'
          iconPrefix={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M8.47115 11.4692L13.9711 5.99976L15.0289 7.06337L10.0636 12.001L15.0289 16.9387L13.9711 18.0023L8.47115 12.5328C8.32959 12.392 8.25 12.2007 8.25 12.001C8.25 11.8014 8.32959 11.61 8.47115 11.4692Z" fill={COLORS.FG.DEFAULT}/></svg>}
          onClick={() => setIsDateDrawerOpen(true)}
        />
        <Button 
          label="Все"
          colorScheme="neutral"
          iconPrefix={<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.875 8.33325C12.2202 8.33325 12.5 8.61307 12.5 8.95825C12.5 9.30343 12.2202 9.58325 11.875 9.58325H8.125C7.77982 9.58325 7.5 9.30343 7.5 8.95825C7.5 8.61307 7.77982 8.33325 8.125 8.33325H11.875Z" fill={COLORS.FG.MUTED}/><path fillRule="evenodd" clipRule="evenodd" d="M17.2917 3.33325C17.4067 3.33325 17.5 3.42653 17.5 3.54159V6.87492C17.5 6.98998 17.4067 7.08325 17.2917 7.08325H16.6667V14.9999C16.6667 15.9204 15.9205 16.6666 15 16.6666H5C4.07953 16.6666 3.33333 15.9204 3.33333 14.9999V7.08325H2.70833C2.59327 7.08325 2.5 6.98998 2.5 6.87492V3.54159C2.5 3.42653 2.59327 3.33325 2.70833 3.33325H17.2917ZM4.58333 14.9999C4.58333 15.23 4.76988 15.4166 5 15.4166H15C15.2301 15.4166 15.4167 15.23 15.4167 14.9999V7.08325H4.58333V14.9999ZM3.75 5.83325H16.25V4.58325H3.75V5.83325Z" fill={COLORS.FG.MUTED}/></svg>}
          onClick={() => setIsHiveDrawerOpen(true)}
        />

        <Drawer
          isOpen={isDateDrawerOpen}
          position='bottom'
          onClose={() => setIsDateDrawerOpen(false)}
        >
          <DrawerDateWrapper>
            <PickerDate 
              activeDate={activeDate}
              onSelect={(activeDate: Date) => {onChangeFilters({date: activeDate}); setIsDateDrawerOpen(false)}}
            />
          </DrawerDateWrapper>
        </Drawer>
        <Drawer
          position="bottom"
          isOpen={isHiveDrawerOpen}
          onClose={() => setIsHiveDrawerOpen(false)}
        >
          <DrawerHivesWrapper>
            <h3>Номер улья</h3>
            <SearchList 
              items={hiveListItems}
              onItemClick={onHiveListItemClick}
            />
          </DrawerHivesWrapper>
        </Drawer>
      </CalendarCalendarHead>
      }

      <CalendarCalendar 
        activeDate={activeDate}
        events={events}
        onChangeFilters={onChangeFilters}
        onEventDrop={onEventDrop}
        onEventResize={onEventResize}
        eventIdFromUrl={searchParams.get("id") || undefined}
        onEventOpen={() => {
          // Удаляем параметр id из URL после открытия события
          searchParams.delete('id');
          setSearchParams(searchParams, { replace: true });
        }}
        openEventModal={() => setIsNewEventOpen(true)}
      />

      {!isScreenLg&&!isToday(activeDate) && 
      <CaletdatFluidToTodayButton onClick={() => onChangeFilters({date: new Date()})}>
        Сегодня
      </CaletdatFluidToTodayButton>
      }

      <CalendarNewEvent 
        isOpen={isNewEventOpen}
        onClose={() => setIsNewEventOpen(false)}
      />
    </CalendarWrapper>
  )
}